import { BlockchainContext } from "../context/BlockchainContext";
import { useContext, useState, useRef } from "react";
import CountdownTimer from "../Components/CountdownTimer/CountdownTimer";

export default function LockedStaking() {
  const {
    useRef,
    onDeposit,
    depositRef,
    depositTokens,
    withdrawTokens,
    onWithDraw,
    withdrawRef,
    connectWallet,
    claimToken,
    approveLockedStake,
    depositLockedTokens,
    withdrawLockedTokens,
    emergencyWithdraw,
    withdrawLockedRewards,
  } = useContext(BlockchainContext);
  async function refreshPage() {
    {
      connectWallet();
    }
  }
  /*
APY
Total Staked Tokens
Rewards Remaining in the pool
Your locked tokens
your pending rewards
Your token balance
your unlock date
input box
approve
claim
emergency withdraw
*/
  return (
    <div className="center">
      <div className="grid">
        <p className="boxNumber">7 day lock</p>
        <div className="gridbox">
          <div className="gridbutton" onClick={refreshPage}>
            Connect
          </div>
          <div className="gridbutton" onClick={approveLockedStake}>
            Approve Staking
          </div>
        </div>
        <div className="gridbox">
          Fixed APY
          <div className="gridnumber" id="lockedAPR">
            %
          </div>
        </div>
        <div className="gridbox">
          Total Staked
          <div className="gridnumber" id="totalLockedStake"></div>
        </div>{" "}
        <div className="gridbox">
          early withdrawal fee
          <div className="gridnumber" id="exitPenaltyPerc">
            %
          </div>
        </div>
        <div className="gridbox">
          Your Token Balance
          <div className="gridnumber" id="LockedTokenBalance">
            0
          </div>
        </div>
        <div className="gridbox">
          Your Locked Tokens
          <div className="gridnumber" id="userLocked">
            0
          </div>
        </div>
        <div className="gridbox">
          Pending Rewards
          <div className="gridnumber" id="lockedPendingRewards">
            0
          </div>
        </div>
        <form className="gridbox" onChange={onWithDraw}>
          <input
            className="gridbutton"
            placeholder="INPUT VALUE"
            ref={withdrawRef}
            type="number"
          />
          <button
            className="gridbutton"
            onClick={withdrawLockedRewards}
            type="submit"
          >
            Claim
          </button>
        </form>
        <div className="gridbox">
          <form className="stats" onChange={onDeposit}>
            <input
              className="gridbutton"
              placeholder="INPUT VALUE"
              ref={depositRef}
              type="number"
            />
          </form>
          <button
            className="gridbutton"
            onClick={depositLockedTokens}
            type="submit"
          >
            DEPOSIT
          </button>
        </div>
        <div className="gridbox">
          Are you a jeet?
          <button className="gridbutton" onClick={emergencyWithdraw}>
            I am Jeet
          </button>
        </div>
        <div className="gridbox">
          Lock Period is over{" "}
          <button
            className="gridbutton"
            onClick={withdrawLockedTokens}
            type="submit"
          >
            Withdraw
          </button>
        </div>{" "}
        <div className="gridbox" id="holderUnlockTime">
          Your Unlock Date
          <div className="gridbutton" onClick={refreshPage}>
            check unlock date
          </div>{" "}
        </div>
        <div className="nullBox">
          <div id="APR"></div>
          <div id="StakedTokens"></div>
          <div id="balance"></div>
          <div id="pendingRewards"></div>
          <div id="depositedTokens"></div>
          <div id="earned"></div>
          <div id="getstakednfts"></div>
          <div id="costofmint"></div>
          <div id="totalSupply"></div>
          <div id="maxSupply"></div>
          <div id="totalnftstaked"></div>
          <div id="earned"></div>
          <div id="userLocked"></div>
          <div id="lockedPendingRewards"></div>
          <div id="holderUnlockTime"></div>
          <div id="lockedAPR"></div> <div id="totalLockedStake"></div>{" "}
          <div id="exitPenaltyPerc"></div> <div id="LockedTokenBalance"></div>{" "}
        </div>{" "}
      </div>
    </div>
    /*
        <div className="">
      <div className="transform">
        <div className="containerCol">
          <div className="">
            <div className="boxbutton2" onClick={refreshPage}>
              Refresh Data
            </div>
          </div>
        </div>
        <div className="containerRow">
          <div className="box">
            Your Balance
            <div className="boxNumber" id="LockedTokenBalance"></div>
          </div>
          <div className="box">
            Fixed APY %
            <div className="boxNumber" id="lockedAPR">
              %
            </div>
          </div>

          <div className="box">
            Your Locked Tokens
            <div className="boxNumber" id="userLocked"></div>
          </div>
        </div>
        <div className="containerRow">
          <div className="box">
            Pending Rewards
            <div className="boxNumber" id="lockedPendingRewards"></div>
            <form className="stats" onChange={onWithDraw}>
              <input
                className="input"
                placeholder="INPUT VALUE"
                ref={withdrawRef}
                type="number"
              />
            </form>
            <button
              className="boxbutton"
              onClick={withdrawLockedRewards}
              type="submit"
            >
              Claim
            </button>
          </div>
          <div className="boxCol">
            Deposit Tokens{" "}
            <form className="stats" onChange={onDeposit}>
              <input
                className="input"
                placeholder="INPUT VALUE"
                ref={depositRef}
                type="number"
              />
            </form>
            <div className="boxbutton2" onClick={approveLockedStake}>
              APPROVE STAKING
            </div>
            <button
              className="boxbutton"
              onClick={depositLockedTokens}
              type="submit"
            >
              DEPOSIT
            </button>
          </div>{" "}
          <div className="box">
            Total Staked
            <div className="boxNumber" id="totalLockedStake"></div>
          </div>{" "}
        </div>
        <div className="containerRow">
          <div className="boxLong" id="holderUnlockTime">
            Your Unlock Date
          </div>{" "}
        </div>
        <div className="containerRow">
          <div className="box">
            early withdrawal %
            <div className="boxNumber" id="exitPenaltyPerc">
              %
            </div>
          </div>
          <div className="box">
            Are you a jeet?
            <button className="boxbutton" onClick={emergencyWithdraw}>
              I am Jeet
            </button>
          </div>
          <div className="box">
            Lock Period is over{" "}
            <button
              className="boxbutton"
              onClick={withdrawLockedTokens}
              type="submit"
            >
              Withdraw
            </button>
          </div>
        </div>
      </div>{" "}
      <div className="containerRow">
        <div id="APR"></div>
        <div id="StakedTokens"></div>
        <div id="balance"></div>
        <div id="pendingRewards"></div>
        <div id="depositedTokens"></div>
        <div id="earned"></div>
        <div id="getstakednfts"></div>
        <div id="costofmint"></div>
        <div id="totalSupply"></div>
        <div id="maxSupply"></div>
        <div id="totalnftstaked"></div>
        <div id="earned"></div>
        <div id="getstakednfts"></div>{" "}
      </div>
    </div> */
  );
}
